import changeCase from 'change-case';
import {
  COMMON_CHUNK_NAME,
  FUNCTION_DEFINE_CHUNK_NAME,
  DEFAULT_LINK_AFTER,
} from '../../../const/generator';
import { REACT_CHUNK_NAME } from './const';

import {
  BuilderComponentPlugin,
  BuilderComponentPluginFactory,
  ChunkType,
  FileType,
  ICodeStruct,
  IContainerInfo,
} from '../../../types';
import { ensureValidClassName } from '../../../utils/validate';

const pluginFactory: BuilderComponentPluginFactory<unknown> = () => {
  const plugin: BuilderComponentPlugin = async (pre: ICodeStruct) => {
    const next: ICodeStruct = {
      ...pre,
    };

    const ir = next.ir as IContainerInfo;

    // 如果 moduleName 为 index，则取 modulePaths 的最后一个作为命名依据
    const isIndexModule = ir.moduleName.toLowerCase() === 'index';
    const effectiveModuleName =
      isIndexModule && ir.modulePaths && ir.modulePaths.length > 0
        ? ir.modulePaths[ir.modulePaths.length - 1]
        : ir.moduleName;

    // 将模块名转换成 PascalCase 的格式，并添加特定后缀，防止命名冲突
    const componentClassName = ensureValidClassName(
      `${changeCase.pascalCase(effectiveModuleName)}${ir.containerType}`,
    );

    next.chunks.push({
      type: ChunkType.STRING,
      fileType: FileType.TSX,
      name: FUNCTION_DEFINE_CHUNK_NAME.Start,
      content: `export default function ${componentClassName}(props) {`,
      linkAfter: [
        COMMON_CHUNK_NAME.ExternalDepsImport,
        COMMON_CHUNK_NAME.InternalDepsImport,
        COMMON_CHUNK_NAME.ImportAliasDefine,
        COMMON_CHUNK_NAME.FileVarDefine,
        COMMON_CHUNK_NAME.FileUtilDefine,
      ],
    });

    next.chunks.push({
      type: ChunkType.STRING,
      fileType: FileType.TSX,
      name: FUNCTION_DEFINE_CHUNK_NAME.End,
      content: '}',
      linkAfter: [
        REACT_CHUNK_NAME.FunctionRenderJSX,
        ...DEFAULT_LINK_AFTER[FUNCTION_DEFINE_CHUNK_NAME.End],
      ],
    });

    next.chunks.push({
      type: ChunkType.STRING,
      fileType: FileType.TSX,
      name: COMMON_CHUNK_NAME.FileExport,
      content: '',
      linkAfter: [
        COMMON_CHUNK_NAME.ExternalDepsImport,
        COMMON_CHUNK_NAME.InternalDepsImport,
        COMMON_CHUNK_NAME.ImportAliasDefine,
        COMMON_CHUNK_NAME.FileVarDefine,
        COMMON_CHUNK_NAME.FileUtilDefine,
        FUNCTION_DEFINE_CHUNK_NAME.End,
      ],
    });

    return next;
  };
  return plugin;
};

export default pluginFactory;
